import React from "react";
import { connect } from "react-redux";
import { Collections } from "../../components/Collection";
import { DashboardHeader } from "../../components/Header";

class CollectionsScreen extends React.Component {
  render() {
    return (
      <div className="card">
        <div className="card-body">
          <DashboardHeader
            title={"Collections"}
            titleClassName="text-primary"
          />
          <Collections showAdd />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(CollectionsScreen);
